import React from "react";

const DoubleArrowLeft = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            fill={fill}
            d="m2 18.111 14.967 15.111 3.41-3.443L8.82 18.111 20.377 6.443 16.967 3 2 18.111Zm13.623 0L30.59 33.222 34 29.78 22.443 18.111 34 6.443 30.59 3 15.623 18.111Z"
        />
    </svg>
);

export default DoubleArrowLeft;